<template>
  <div>
    <el-tabs v-model="type" @tab-click="tabChange">
      <el-tab-pane label="staking用户总持仓" name="total"></el-tab-pane>
      <el-tab-pane label="用户持仓详细" name="detail"></el-tab-pane>
    </el-tabs>
    <el-card v-show="type == 'total'">
      <el-table v-if="tableAble" :data="totalStakingPosition">
        <el-table-column label="币种" prop="coinType"></el-table-column>
        <el-table-column label="持仓" prop="amount"></el-table-column>
        <el-table-column label="解锁中" prop="unlocking"></el-table-column>
      </el-table>
    </el-card>
    <el-card v-show="type == 'detail'">
      <el-input
        v-model="userId"
        size="mini"
        @change="queryStakingData"
        placeholder="用户ID"
        class="search"
      ></el-input>
      <el-input
        v-model="coinType"
        size="mini"
        @change="queryStakingData"
        placeholder="币种"
        class="search"
      ></el-input>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="queryStakingData()"
        circle
        size="mini"
      ></el-button>
      <el-table v-if="tableAble" :data="userStakingPosition">
        <el-table-column label="币种" prop="coinType"></el-table-column>
        <el-table-column label="用户ID" prop="userId"></el-table-column>
        <el-table-column label="当前持仓数量" prop="amount"></el-table-column>
        <el-table-column label="解锁中数量" prop="unlocking"></el-table-column>
        <el-table-column label="锁定路上数量" prop="locking"></el-table-column>
      </el-table>
      <div class="pager-wrap">
      </div>
    </el-card>
  </div>
</template>
<script>
import "../store.js";
import { mapState, mapActions } from "vuex";
import { formatTable } from "../../../common/tools.js";
export default {
  name: "dataCenterStakingPosition",
  data() {
    return {
      type: "total",
      coinType: "",
      userId: "",
      
    };
  },
  methods: {
    ...mapActions("dataCenter", [
      "getTotalStakingPosition",
      "getUsetStakingPosition",
    ]),
    queryData() {
      this.getTotalStakingPosition();
    },
    queryStakingData() {
      let q = {};
      if (this.coinType) q.coinType = this.coinType;
      if (this.userId) q.userId = this.userId;
      this.getUsetStakingPosition(q);
    },
    tabChange() {
      if (this.type == "total") {
        this.queryData();
      } else {
        this.queryStakingData();
      }
    },
  },
  computed: {
    ...mapState("dataCenter", [
      "userStakingPosition",
      "totalStakingPosition",
      "tableAble"
    ]),
  },
  watch: {
    userStakingPosition() {
      formatTable();
    },
    totalStakingPosition() {
      formatTable();
    },
  },
  mounted() {
    this.queryData();
  },
};
</script>
<style scoped>
.search {
  width: 200px;
  margin: 0px 20px 20px 0px;
}
.date-search {
  margin-right: 20px;
}
</style>
